import styled, {css} from 'styled-components'
import {Text, TextProps} from '@/components/ui/text/Text'

export const StyledHomeCard = styled.div(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 4}px;
        display: flex;
        flex-direction: column;
        gap: ${spacing * 6}px;
        align-items: flex-start;
        justify-content: space-between;
    `
)

export const StyledHomeCardContent = styled.div(
    ({theme: {spacing}}) => css`
        flex: 1;
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: ${spacing * 4}px;
    `
)

// Fills the remaining card height so the empty state sits in the middle of the card
export const StyledEmptyState = styled.div(
    ({theme: {spacing, palette}}) => css`
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: ${spacing * 2}px;
        padding: ${spacing * 4}px;
        border: 1px solid ${palette.neutral['200']};
        border-radius: 12px;
    `
)

// Time | patient | access type, aligned across rows
const eventColumns = css`
    display: grid;
    grid-template-columns: 104px minmax(0, 1fr) auto;
    column-gap: ${({theme}) => theme.spacing * 4}px;
    align-items: center;
`

export const StyledEventsList = styled.div(
    ({theme: {palette}}) => css`
        width: 100%;
        display: flex;
        flex-direction: column;
        border-top: 1px solid ${palette.neutral['100']};
    `
)

export const StyledEventRow = styled.div(
    ({theme: {spacing, palette}}) => css`
        ${eventColumns};
        padding: ${spacing * 2}px 0;
        border-bottom: 1px solid ${palette.neutral['100']};
        min-width: 0;

        & > * {
            min-width: 0;
        }
    `
)

export const StyledEventTime = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing * 1.5}px;
        white-space: nowrap;
        font-variant-numeric: tabular-nums;
    `
)

export const StyledEllipsisText = styled(Text)<TextProps>`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`
